import { setGlobalAlert, updateSoundStatus } from '.'

export default (assetId, abortController) => dispatch => {
    if (assetId || assetId === 0) {
        fetch(`/services/plugin-channel-alarms/alarm-rules/${assetId}/sound`, { signal: abortController.signal })
            .then(r => {
                if (r.ok) {
                    return r.json()
                }

                return new Promise(resolve => resolve({ success: false, error: r.status + ' - ' + r.statusText }))
            })
            .then(r => {
                dispatch(updateSoundStatus(r))
            })
            .catch(err => {
                if (err.name !== 'AbortError') {
                    dispatch(setGlobalAlert('Error getting sound status', false))
                    console.error('Error getting sound status:', err)
                }
            })
    }
}
